import { Injectable, EventEmitter } from '@angular/core';

@Injectable({providedIn: 'root'})
export class NavbarEventManager {
  public showNavBar: EventEmitter<any> = new EventEmitter();
  public hideNavBar: EventEmitter<any> = new EventEmitter();
}
